
import axios from "axios";
import { EXTERNAL_CONNECTION_ERRORS } from "./constants";

//@string msg = '{ title:"sadfasdf", message:"asdfsdf"}'
const createNewNotification = async (message:string) => {
  try {
    const recordRequest = await axios.post(
      `/api/shared/create-new-notification`, 
      {
        data: {
          message:message || ""
        }
      }
    );
    const { data } = recordRequest;
    return data;
  } catch (error) {
    console.error("Utils - Create New Notification - Error:", error);
    throw new Error(EXTERNAL_CONNECTION_ERRORS.GET_RECORD);
  }
};

export default createNewNotification;
